import { IconTable } from '@components/table/IconTable';
import { useTheme } from 'context/ThemeProvider/ThemeProvider';
import { type FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFetchDashboardList } from 'api/dashboard/dashboardServices';
import useGetOrganizationAnomaliesTableColumns from './hook/useGetOrganizationAnomaliesTableColumns';
import { type Anomaly } from 'interfaces/change/ChangeData.interface';
import { useQuerySearch } from './hook/useQuerySearch';
import { useTranslation } from 'react-i18next';

const OrganizationAnomaliesTable: FC = () => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const navigate = useNavigate();
  const { querySearch } = useQuerySearch();
  const { columns } = useGetOrganizationAnomaliesTableColumns();
  const { data: anomaliesData, isFetching } =
    useFetchDashboardList(querySearch);
  console.log('data', anomaliesData);

  const [hoveredId, setHoveredId] = useState<undefined | number>(undefined);

  const navigateToAnomaly = (anomaly: Anomaly): void => {
    if (anomaly) navigate(`/app/operations/anomalies/details/${anomaly.id}`);
  };

  return (
    <div className="rounded-lg">
      <IconTable<Anomaly>
        minHeight={260}
        skeletonAmountWhenLoading={5}
        isFetching={isFetching}
        enableRowBorder={false}
        stripped={false}
        onRowHover={(id) => {
          setHoveredId(id);
        }}
        onClickRow={navigateToAnomaly}
        hoveredId={hoveredId}
        hoverColor={theme.colors['tertiary-lighter']}
        enableRowRoundedBorder={true}
        data={anomaliesData?.anomaly_detections ?? []}
        columns={columns}
        emptyTableMessage={t(
          'organizationView.anomaliesAndProjects.emptyTableMessage'
        )}
      />
    </div>
  );
};
export default OrganizationAnomaliesTable;
